import { LikedButtons } from "./liked-buttons";
import { SaveButtons } from "./save-buttons";
import { useSaveColor } from "../../save-color";
import { useAddToColorCollectionModalStore } from "../../../js/stores/add-to-color-collection-modal-store";
import { addToBasketAction } from "../shared/add-to-basket-action";
import { useUpdateColorStateInCollection } from "../../../js/api/edit-collections/add-to-collection-form";

export function SaveColorButtonsWrapper() {
  const {
    isLoggedIn,
    isBasketEnabled,
    basketPageUrl,
    basketLabel,
    addToCollectionUrl,
    addToCollectionLabel,
    removeFromCollectionUrl,
    removeFromCollectionLabel,
  } = useSaveColor();

  const openModal = useAddToColorCollectionModalStore(
    (state) => state.openModal
  );
  const removeColorMutation = useUpdateColorStateInCollection();
  const removeColorHandler = (url) => {
    removeColorMutation.mutate({
      url,
      successHandler: (data) => {
        if (data?.redirectUrl && window?.location?.href) {
          window.location.href = data?.redirectUrl;
        }
      },
    });
  };
  const basketAction = isBasketEnabled
    ? {
        label: basketLabel,
        clickHandler: () => addToBasketAction(basketPageUrl),
      }
    : null;
  const collectionAction =
    addToCollectionUrl && isLoggedIn
      ? {
          clickHandler: () => openModal(addToCollectionUrl),
          label: addToCollectionLabel,
        }
      : null;
  const removeFromCollectionAction =
    removeFromCollectionUrl && isLoggedIn
      ? {
          clickHandler: () => removeColorHandler(removeFromCollectionUrl),
          label: removeFromCollectionLabel,
        }
      : null;

  return (
    <>
      {!isLoggedIn && (
        <LikedButtons
          basketAction={basketAction}
          collectionAction={collectionAction}
        />
      )}
      {isLoggedIn && (
        <SaveButtons
          basketAction={basketAction}
          collectionAction={collectionAction}
          removeFromCollectionAction={removeFromCollectionAction}
        />
      )}
    </>
  );
}
